import styled from "styled-components";
import { Button } from "../Button/Button";
import { useEffect, useState } from "react";
import {
	IEthList,
	ITrxList,
	usePaymentsStore,
} from "../../store/PaymentsStore";
import { usePayment } from "../../hooks/PaymentHook";
import { useMessageStore } from "../../store/MessageStore";

export const PaymentList = () => {
	const [network, setNetwork] = useState("tron");
	const [usdt, setUsdt] = useState(0);
	const [token, setToken] = useState(0);
	const [checkbox, setCheckbox] = useState<string[]>([]);
	const [toAddress, setToAddress] = useState<string>("");
	const { ethereumList, tronList } = usePaymentsStore();

	const { CollectHandler, GetPaymentsList } = usePayment();
	const addMessage = useMessageStore((state) => state.addMessage);

	const list = network === "tron" ? tronList : ethereumList;

	const Collecthandler = async (type: "usdt" | "coin") => {
		addMessage("success", "collect_begin");
		const result = await CollectHandler(checkbox, toAddress, type);
		setCheckbox([]);
		if (!result) {
			return;
		}
		if (result.status === "success") {
			await GetPaymentsList(network);
		}
	};

	const CheckboxHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		const usdt = e.target.attributes.getNamedItem("data-usdt")?.value || 0;
		const token =
			e.target.attributes.getNamedItem("data-token")?.value || 0;

		if (checkbox.includes(value)) {
			setToken((state) => state - +token);
			setUsdt((state) => state - +usdt);
			setCheckbox([...checkbox.filter((v) => v !== value)]);
		} else {
			setToken((state) => state + +(+token).toFixed(2));
			setUsdt((state) => state + +(+usdt).toFixed(2));
			setCheckbox([...checkbox, value]);
		}
	};

	useEffect(() => {
		GetPaymentsList(network);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [network]);

	return (
		<StyledComponent>
			<div className="network">
				<Button
					className={network === "tron" ? "selected" : ""}
					onClick={() => setNetwork("tron")}
				>
					Tron
				</Button>
				<Button
					className={network === "ethereum" ? "selected" : ""}
					onClick={() => setNetwork("ethereum")}
				>
					Ethereum
				</Button>
			</div>
			<div className="formBtns">
				<span>{usdt.toFixed(2)} USDT</span>
				<span>{token.toFixed(2)} Token</span>
				<input
					type="text"
					value={toAddress}
					onChange={(e) => setToAddress(e.target.value)}
					placeholder="Сбор на кошелёк"
				/>
				<Button
					className="tokens"
					onClick={() => Collecthandler("coin")}
				>
					{network === "tron" ? "Собрать TRX" : "Собрать ETH"}
				</Button>
				<Button className="usd" onClick={() => Collecthandler("usdt")}>
					Собрать USDT
				</Button>
			</div>
			{list &&
				list.map((value) => {
					return (
						<div className="payment" key={value.address}>
							<div className="userName">{value.user_name}</div>
							<div className="address">{value.address}</div>
							<div className="coin">
								{network === "tron"
									? `${(value as ITrxList).trx.toFixed(
											2
									  )} TRX`
									: `${(value as IEthList).eth.toFixed(
											6
									  )} ETH`}
							</div>
							<div className="usdt">
								{value.coins.toFixed(2)} USDT
							</div>
							<input
								type="checkbox"
								name="address[]"
								value={value.address}
								style={{ width: "20px" }}
								data-usdt={value.coins.toFixed(2)}
								data-token={
									network === "tron"
										? (value as ITrxList).trx.toFixed(2)
										: (value as IEthList).eth.toFixed(2)
								}
								onChange={(e) => CheckboxHandler(e)}
							/>
						</div>
					);
				})}
			<div className="formBtns">
				<Button
					className="tokens"
					onClick={() => Collecthandler("coin")}
				>
					{network === "tron" ? "Собрать TRX" : "Собрать ETH"}
				</Button>
				<Button className="usd" onClick={() => Collecthandler("usdt")}>
					Собрать USDT
				</Button>
			</div>
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	overflow-y: auto;

	& .formBtns {
		display: flex;
		justify-content: end;
		align-items: center;
		gap: 3rem;

		& input {
			flex-grow: 1;
		}
	}

	& .network {
		display: flex;
		justify-content: center;
		gap: 1rem;

		& button {
			flex-grow: 1;

			&.selected {
				background-color: rgba(255, 255, 255, 0.1);
			}
		}
	}

	& .payment {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		gap: 0.5rem;

		&:hover {
			background-color: rgba(255, 255, 255, 0.1);
		}

		& > div {
			padding: 0.5rem;
		}

		& .userName,
		& .coin,
		& .usdt {
			width: 150px;
		}

		& .coin,
		& .usdt {
			text-align: end;
		}

		& .address {
			flex-grow: 1;
		}

		& button.usd {
			color: lightblue;
		}
		& button.tokens {
			color: lightgoldenrodyellow;
		}
	}
`;
